import React from "react";
import Badge from "../Shared/Product/Badge";

const AddBadge = ({ text, price }) => {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-6">
        <label>
          <input type="checkbox" />
        </label>
        <div className="relative h-24 w-32 overflow-hidden bg-paginateBgGray">
          <Badge className="top-3 left-5 text-sm" text={text} />
        </div>
        <span className="font-pop text-xl text-black opacity-50">{text}</span>
      </div>
      <span className="justify-self-end font-pop text-xl text-black opacity-50">
        R{typeof price === "number" ? price.toFixed(2) : 0}
      </span>
    </div>
  );
};

export default AddBadge;
